import { useCallback, useState } from 'react'

export const useInteractionFreeze = () => {
  const [isInteracting, setIsInteracting] = useState(false)
  const handleInteractionStart = useCallback(() => setIsInteracting(true), [])
  const handleInteractionEnd = useCallback(() => {
    setTimeout(() => setIsInteracting(false), 0)
  }, [])

  return { isInteracting, handleInteractionStart, handleInteractionEnd }
}
